import { useTranslation } from "react-i18next";
import awardLabelContent from "../../content/awardLabels";

/**
 * Returns the localized "no data available" label string from the awardLabels namespace.
 * Use this as an aria-label whenever a value renders as "--" to aid screen readers.
 */
export const useNoDataAvailableLabel = (): string => {
  const { t } = useTranslation(["awardLabels"]);
  return t("awardLabels.no-data-available", awardLabelContent.awardLabels["no-data-available"] as string, {
    ns: "awardLabels",
  });
};
